import './DailyOverviewChart.css'
import { Chart, ArcElement, Tooltip, Legend } from 'chart.js';
import { Doughnut } from 'react-chartjs-2';
import useQuarantinedTests from '../../hooks/useQuarantinedTests';
import StatusBadge from './StatusBadge';

Chart.register(ArcElement, Tooltip, Legend);

const UnitBreakdownChart = ({ selectedPlatform }) => {
    const { data, loading, error } = useQuarantinedTests(selectedPlatform, "All units");

    if (loading) return (
        <div className="empty-card">
            <div className="metric-header">
                <h2>Unit</h2>
                <StatusBadge status="loading" label="Loading" />
            </div>
            <div className="chart-box">
                <img className="flashing" style={{ height: '100%' }} src={require('../../assets/loading-chart.png')} alt="Loading chart" />
            </div>
        </div>
    );

    if (error) return (
        <div className="empty-card">
            <div className="metric-header">
                <h2>Unit</h2>
                <StatusBadge status="error" label="Error" className="flashing" />
            </div>
            <div className="chart-box">
                <img className="flashing" style={{ height: '100%' }} src={require('../../assets/error-chart.png')} alt="Error chart" />
            </div>
        </div>
    );

    if (!data || data.length === 0) return (
        <div className="empty-card">
            <div className="metric-header">
                <h2>Unit</h2>
                <StatusBadge status="no-data" label="No data" className="flashing" />
            </div>
            <div className="chart-box">
                <img className="flashing" style={{ height: '100%' }} src={require('../../assets/no-data-chart.png')} alt="No data chart" />
            </div>
        </div>
    );

    // Group tests by unit
    const unitCounts = data.reduce((acc, test) => {
        const unit = test.unit || 'Unknown';
        acc[unit] = (acc[unit] || 0) + 1;
        return acc;
    }, {});

    const units = Object.keys(unitCounts);
    const counts = Object.values(unitCounts);

    // Generate colors for each unit (different color palette from platform chart)
    const colors = [
        '#FF6B6B', '#4ECDC4', '#45B7D1', '#96CEB4', '#FFEAA7',
        '#DDA0DD', '#98D8C8', '#F7DC6F', '#BB8FCE', '#85C1E9'
    ];

    const chartData = {
        labels: units,
        datasets: [
            {
                data: counts,
                backgroundColor: colors.slice(0, units.length),
                borderWidth: 2,
                borderColor: '#fff'
            },
        ],
    };

    const options = {
        plugins: {
            legend: {
                display: false,
            },
            tooltip: {
                callbacks: {
                    label: function(context) {
                        const label = context.label || '';
                        const value = context.parsed;
                        const total = context.dataset.data.reduce((a, b) => a + b, 0);
                        const percentage = ((value / total) * 100).toFixed(1);
                        return `${label}: ${value} tests (${percentage}%)`;
                    }
                }
            }
        },
        maintainAspectRatio: false,
    };

    return (
        <div className="empty-card">
            <div className="metric-header">
                <h2>Unit</h2>
            </div>
            <div className="chart-box">
                <Doughnut data={chartData} options={options} />
            </div>
        </div>
    );
};

export default UnitBreakdownChart;